export const API_DOMAIN = "https://router.rexboy.workers.dev";
